import { render } from "./ListContactTypes.vue?vue&type=template&id=514db1d9"
import script from "./ListContactTypes.vue?vue&type=script&lang=js"
export * from "./ListContactTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__